/**
 * 路由网关重构 唉 为什么我总接到这些重构的东西啊  面试时候不把关吗？？？？？？
 * date:2022 03 24 brian
 */
import httpRequest from '@/utils/request.js'
import qs from 'qs'

/** 获取网关列表 */
export const gatewayList = (params = {}, way) =>
  httpRequest.httpGet({
    url: '/service/gateway/lst/' + way,
    params: {
      ...params
    }
  })
/** 获取网关配置参数 */
export const getNetConfig = (params = {}) =>
  httpRequest.httpGet({
    url: '/service/gateway/getNetConfig',
    params: {
      ...params
    }
  })
/** 获取网关配置信息 */
export const getConfiglogList = (params = {}) =>
  httpRequest.httpGet({
    url: '/service/gateway/getConfiglogList',
    params: {
      ...params
    }
  })
/** 获取网关详情信息 */
export const getGatewayDetailInfo = id =>
  httpRequest.httpGet({
    url: '/service/gateway/getGatewayDetailInfo/' + id
  })
/** 更新网关状态 */
export const gatewayUpdateStatus = (data, way) =>
  httpRequest.httpPost('/service/gateway/edit/' + way, data)
/** 更新网关网络参数 */
export const gatewayUpdateNetConfig = data =>
  httpRequest.httpPost('/service/gateway/updateNetConfig', data)
/** 获取网关详情 */
export const gatewayGetDetailConfig = data =>
  httpRequest.httpPost('/service/gateway/getDetailConfig/', data)
/** 获取网关历史心跳 */
export const gatewayhistoryList = (params = {}) =>
  httpRequest.httpGet({
    url: '/service/gateway/history/lst',
    params: {
      ...params
    }
  })
/** 网关表格模板 */
export const generaUploadTemplateFile = data =>
  httpRequest.download('/service/gateway/generaUploadTemplateFile', data)
// 导入网关模板
export const importGateway = data =>
  httpRequest.httpPost('/service/gateway/importGateway', data)
/** 更新网关网络参数 */
export const gatewayDel = data =>
  httpRequest.httpdelete('/service/gateway/del', data)
/** 更新网关基础信息 */
export const gatewayUpdate = data =>
  httpRequest.httpPut('/service/gateway/update', data)
/** 网关新增 */
export const getAddGateway = data =>
  httpRequest.httpPost('/service/gateway/addGateway', data)
/** 网关编辑 */
export const getEditGateway = data =>
  httpRequest.httpPost('/service/gateway/editGateway', data)
/** 网关删除配置 */
export const delMsgGateway = data =>
  httpRequest.httpdelete('/service/gateway/delConfig', data)

// 获取网关报警配置
export const getAlarmConfig = params =>
  httpRequest.httpGet({
    url: '/service/gateway/getAlarmConfig',
    params
  })

// 保存网关报警配置
export const saveAlarmConfig = params =>
  httpRequest.httpPut('/service/gateway/updateAlarmConfig', params)

// 获取二代网关配置
export const getGenTwoGatewayConfig = params =>
  httpRequest.httpGet({
    url: '/service/gateway/getAndroidNetConfig',
    params
  })

// 设置二代网关配置
export const updateGenTwoGatewayConfig = data =>
  httpRequest.httpPost('/service/gateway/updateAndroidNetConfig', data)

/**
 * 网关修改客户
 */
export const updateCustomer = data =>
  httpRequest.httpPost('/service/gateway/update/customer', qs.stringify(data))
